import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TrendIcon from "../Trend/Icon.js";
import { formatValue } from "../utils/data.js";
import { getDirection, getTrendClassName } from "../utils/trends.js";
const TrendWrapper = styled(Box)(() => ({
  display: "inline-flex",
  alignItems: "center",
  gap: "0.25rem"
}));
const TrendValue = styled(Typography)(({
  theme
}) => ({
  borderRadius: theme.sizes.radius.full,
  overflow: "hidden",
  display: "inline-flex",
  alignItems: "center",
  gap: theme.sizes.spacing["02"]
}));
const CellWithAbsoluteTrend = (t0) => {
  const $ = c(24);
  const {
    value,
    desiredTrend,
    columnType,
    type,
    format
  } = t0;
  const t1 = !(columnType === "percentage");
  const t2 = type !== "integer" ? 2 : 0;
  let direction;
  let directionClass;
  let t3;
  if ($[0] !== columnType || $[1] !== desiredTrend || $[2] !== format || $[3] !== t1 || $[4] !== t2 || $[5] !== value) {
    const formatOptions = {
      type: columnType,
      short: t1,
      precision: t2,
      ...format
    };
    const ratio = (value ?? 0) + 1;
    let t42;
    if ($[9] !== desiredTrend || $[10] !== ratio) {
      direction = getDirection(ratio);
      t42 = getTrendClassName(direction, desiredTrend);
      $[9] = desiredTrend;
      $[10] = ratio;
      $[11] = direction;
      $[12] = t42;
    } else {
      direction = $[11];
      t42 = $[12];
    }
    directionClass = t42;
    t3 = formatValue(value, formatOptions);
    $[0] = columnType;
    $[1] = desiredTrend;
    $[2] = format;
    $[3] = t1;
    $[4] = t2;
    $[5] = value;
    $[6] = direction;
    $[7] = directionClass;
    $[8] = t3;
  } else {
    direction = $[6];
    directionClass = $[7];
    t3 = $[8];
  }
  const formattedValue = t3;
  const hasValidValue = value !== null && value !== void 0 && !isNaN(value);
  const t4 = hasValidValue ? formattedValue : "—";
  let t5;
  if ($[13] !== directionClass || $[14] !== t4) {
    t5 = /* @__PURE__ */ jsx(TrendValue, { variant: "number-sm", className: directionClass, children: t4 });
    $[13] = directionClass;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== desiredTrend || $[17] !== direction || $[18] !== hasValidValue) {
    t6 = hasValidValue && /* @__PURE__ */ jsx(TrendIcon, { direction, size: "sm", desiredTrend });
    $[16] = desiredTrend;
    $[17] = direction;
    $[18] = hasValidValue;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== directionClass || $[21] !== t5 || $[22] !== t6) {
    t7 = /* @__PURE__ */ jsxs(TrendWrapper, { className: directionClass, children: [
      t5,
      t6
    ] });
    $[20] = directionClass;
    $[21] = t5;
    $[22] = t6;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  return t7;
};
export {
  CellWithAbsoluteTrend as default
};
